import React from 'react';

export const cpcVaultingCashPickUpConfig = [
  {
    path: '/cpc-vaulting-cash-pick-up',
    component: React.lazy(() => import('./listing/listing')),
  },
  {
    path: '/cpc-vaulting-cash-pick-up/add',
    component: React.lazy(() => import('./add/add')),
  },
  {
    path: '/cpc-vaulting-cash-pick-up/view',
    component: React.lazy(() => import('./view/view')),
  },
];
